import { CompleteMultipartUploadCommandOutput, GetObjectCommand } from '@aws-sdk/client-s3'
import { GetObjectCommandOutput } from '@aws-sdk/client-s3/dist-types/commands/GetObjectCommand'

import { APP_CONFIG } from 'src/config.app'
import { getS3Client, multipartUpload } from '../aws/s3'

/**
 * upload file to S3 using the given path
 */
export async function uploadFileToS3(
    localFile: File,
    path: string
): Promise<CompleteMultipartUploadCommandOutput> {
    return await multipartUpload(await getS3Client(), localFile, {
        Bucket: APP_CONFIG.s3MediaBucketAccessPointARN,
        Key: path,
    })
}

export async function downloadFileFromS3(path: string): Promise<GetObjectCommandOutput> {
    const client = await getS3Client()
    return await client.send(
        new GetObjectCommand({
            Bucket: APP_CONFIG.s3MediaBucketAccessPointARN,
            Key: path,
        })
    )
}
